import { Component, Input } from '@angular/core';
import { ErrorService } from 'src/app/core/error.service';
import { Seller, SellersService } from 'src/app/core/sellers.service';
import { StoreMembership, StoreMembershipsService } from 'src/app/core/store-memberships.service';

@Component({
  selector: 'app-seller-details-general',
  templateUrl: './seller-details-general.component.html',
  styleUrls: ['./seller-details-general.component.scss'],
})
export class SellerDetailsGeneralComponent {
  @Input() seller_id?: string | null;

  seller?: Seller;
  stores?: StoreMembership[];
  is_read_running = false;
  is_read_stores_running = false;

  constructor(
    private sellers_service: SellersService,
    private store_membership_service: StoreMembershipsService,
    private error_service: ErrorService,
  ) {}

  ngOnInit(): void {
    this.readSeller(this.seller_id as string);
    this.stores = [];
    if (this.seller_id) this.listStore(this.seller_id);
  }

  onRefresh(): void {
    this.readSeller(this.seller_id as string);
    this.stores = [];
    if (this.seller_id) this.listStore(this.seller_id);
  }

  readSeller(seller_id: string): void {
    this.is_read_running = true;
    this.sellers_service.readSeller(seller_id).subscribe({
      next: response => {
        this.seller = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }

  listStore(seller_id?: string): void {
    this.is_read_stores_running = true;

    if (seller_id) {
      this.store_membership_service.listStoreMembershipsBySellerId(seller_id).subscribe({
        next: response => {
          this.stores = response.data;
          this.is_read_stores_running = false;
        },
        error: error => {
          this.is_read_stores_running = false;
        },
      });
    }
  }
}
